export default "__VITE_ASSET__BOuNQpGb__"